// slug.utils.ts

// Converts a page title into the canonical path used across every "create/rename page" flow -
// lowercase, hyphen-joined, punctuation stripped. Kept in one place so all three page-creation
// surfaces (v2-editor, pages-seo, page-edit) always produce the same path for the same title.
export function slugifyPath(name: string): string {
  const slug = (name || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return '/' + slug;
}
